'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface ServiceFilterProps {
  categories: string[];
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

const ServiceFilter: React.FC<ServiceFilterProps> = ({
  categories,
  activeCategory,
  onCategoryChange,
}) => {
  return (
    <div data-component-id="src/app/services/components/ServiceFilter.tsx:18:4" data-component-path="src/app/services/components/ServiceFilter.tsx" data-component-line="18" data-component-end-line="46" data-component-file="ServiceFilter.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-wrap%20gap-3%20justify-center%22%7D" className="flex flex-wrap gap-3 justify-center">
      {categories.map((category) => (
        <button data-component-id="src/app/services/components/ServiceFilter.tsx:20:8" data-component-path="src/app/services/components/ServiceFilter.tsx" data-component-line="20" data-component-end-line="44" data-component-file="ServiceFilter.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
          key={category}
          onClick={() => onCategoryChange(category)}
          className={`relative px-6 py-3 rounded-lg font-body font-medium transition-all duration-300 ${
            activeCategory === category
              ? 'bg-secondary text-foreground shadow-cosmic'
              : 'bg-card text-muted-foreground hover:bg-muted hover:text-foreground border border-border'
          }`}
        >
          <span data-component-id="src/app/services/components/ServiceFilter.tsx:29:10" data-component-path="src/app/services/components/ServiceFilter.tsx" data-component-line="29" data-component-end-line="40" data-component-file="ServiceFilter.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22relative%20z-10%20flex%20items-center%20space-x-2%22%7D" className="relative z-10 flex items-center space-x-2">
            <Icon data-component-id="src/app/services/components/ServiceFilter.tsx:30:12" data-component-path="src/app/services/components/ServiceFilter.tsx" data-component-line="30" data-component-end-line="38" data-component-file="ServiceFilter.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D"
              name={
                category === 'All Services' ?'SparklesIcon'
                  : category === 'Numerology' ?'CalculatorIcon'
                  : category === 'Astrology' ?'GlobeAltIcon'
                  : category === 'Remedies' ?'HeartIcon' :'BoltIcon'
              }
              size={18}
            />
            <span data-component-id="src/app/services/components/ServiceFilter.tsx:39:12" data-component-path="src/app/services/components/ServiceFilter.tsx" data-component-line="39" data-component-end-line="39" data-component-file="ServiceFilter.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D">{category}</span>
          </span>
          {activeCategory === category && (
            <span data-component-id="src/app/services/components/ServiceFilter.tsx:42:12" data-component-path="src/app/services/components/ServiceFilter.tsx" data-component-line="42" data-component-end-line="42" data-component-file="ServiceFilter.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22absolute%20inset-0%20bg-gradient-to-r%20from-secondary%20to-accent%20opacity-20%20rounded-lg%22%7D" className="absolute inset-0 bg-gradient-to-r from-secondary to-accent opacity-20 rounded-lg"></span>
          )}
        </button>
      ))}
    </div>
  );
};

export default ServiceFilter;